import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {parseHtmlForReact} from '../helpers'
//import '../../assets/css/otherTextInput.css';

const otherInstruction = {
    'ar': 'يرجى التحديد',
    'az_AZ': 'Please specify',
    'cs_CZ': 'Uve\u010Fte pros\u00EDm',
    'cy': 'Please specify',
    'da_DK': 'Please specify',
    'de_DE': 'Bitte angeben',
    'en_AU': 'Please specify',
    'en_GB': 'Please specify',
    'en_US': 'Please specify',
    'es_CO': 'Por favor especifique',
    'es_ES': 'Por favor especifique',
    'es_MX': 'Por favor especifique',
    'fi_FI': 'Please specify',
    'fr_FR': 'Veuillez pr\u00E9ciser',
    'hu_HU': 'Kérem pontosítsa',
    'id_ID': 'Please specify',
    'is_IS': 'Please specify',
    'it_IT': 'Specificare',
    'ja': 'Please specify',
    'ko_KR': 'Please specify',
    'nl_NL': 'Specificeer',
    'no_NO': 'Please specify',
    'pl_PL': 'Prosz\u0119 sprecyzuj',
    'pt_BR': 'Por favor, especifique',
    'pt_PT': 'Please specify',
    'ru_RU': '\u0423\u0442\u043E\u0447\u043D\u0438\u0442\u0435',
    'sv_SE': 'v\u00E4nligen fyll i',
    'th': '\u0E42\u0E1B\u0E23\u0E14\u0E23\u0E30\u0E1A\u0E38',
    'tr_TR': 'L\u00FCtfen belirtin',
    'uk': 'Please specify',
    'zh_CN': '\u8BF7\u6CE8\u660E',
    'zh_TW': '\u8ACB\u8AAA\u660E',
    'vi_VN': 'Please specify',
}


@observer
export default class OtherTextInput extends Component {
    constructor(props){
        super(props)
        this.state = {
            rows: 2,
			minRows: 2,
			maxRows: 10,
        }
        this.handleChange = this.handleChange.bind(this)
        this.autogrow = this.autogrow.bind(this)
    }
    
    componentDidMount() {
    }
    
	handleChange(e) {
		const {other, option, parentQuestion, store} = this.props
		const value = e.target.value
        store.addFormResponse(parentQuestion, value, option, true)
        this.autogrow(e)
    }
    
    autogrow(e) {
        const textareaLineHeight = 24;
		const { minRows, maxRows } = this.state;
		
		const previousRows = e.target.rows;
        e.target.rows = minRows; // reset number of rows in textarea 
            
        const currentRows = ~~(e.target.scrollHeight / textareaLineHeight);
        
        if (currentRows === previousRows) {
            e.target.rows = currentRows;
        }
            
        if (currentRows >= maxRows) {
            e.target.rows = maxRows;
            e.target.scrollTop = e.target.scrollHeight;
        }
        this.setState({
            rows: currentRows < maxRows ? currentRows : maxRows,
        });
    }

	render() {
		var value
		const {other, option, store, parentQuestion} = this.props
		const parentQuestionId = parentQuestion.id
		const {form_data, langcode} = store
		if(parentQuestion.questionTypeCode === "RD"){
			value = form_data.has(parentQuestionId)? form_data.get(parentQuestionId).data.get("other") : ""
		} else {
			value = form_data.has(parentQuestionId)? form_data.get(parentQuestionId).data[option.id].other : ""
        }
        console.log('rows state: ', this.state);
        const placeholder = parseHtmlForReact(otherInstruction[langcode]).props.children
		const valKey = parentQuestion.id+"."+option.id+"_other"
		const validationMsg = parentQuestion.validator.otherValidation[option.id].error ? <p className="validationError radius">{parentQuestion.validator.otherValidation[option.id].message}</p> : null
		return (
			<div className="otherText">
                { parentQuestion.questionTypeCode === "RD" &&
                    <textarea className='radius' id={parentQuestionId+"_"+option.id+"_other"}
                        name={parentQuestionId+"_"+option.id+"_other"}
                        onChange={this.handleChange.bind(this)}
                        onBlur={this.handleChange.bind(this)}
                        value={value}
                        placeholder={placeholder}
                        rows={this.state.rows}
                    />
                }
                 { parentQuestion.questionTypeCode !== "RD" &&
                    <textarea className='radius' id={parentQuestionId+"_"+option.id+"_other"}
                        name={parentQuestionId+"_"+option.id+"_other"}
                        onChange={this.handleChange.bind(this)}
                        onBlur={this.handleChange.bind(this)}
                        defaultValue={value}
                        placeholder={placeholder}
                        rows={this.state.rows}
                    />
                }
				{validationMsg}
			</div>
		)
	}
}
